// FooterComponent.jsx
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from './FooterComponent.module.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { BsTwitterX } from 'react-icons/bs';
import toxboxLogo from "../../../src/Images/logo6.png";
import footerImage from "../../../src/Images/newLandingPage/VectorPNG.png";

const FooterComponent = () => {
  const navigate = useNavigate();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        <div className={styles.leftSection}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={toxboxLogo} alt="ToxBox" className={styles.logoImage} />
            </Link>
          </div>
          <p>Your 24/7 AI receptionist for smarter customer interactions</p>

          <div className={styles.socialIcons}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com/toxbox.ai" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://linkedin.com/company/provaantech" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://x.com/Provaantech" target="_blank" rel="noopener noreferrer"><BsTwitterX /></a>
          </div>
          <div className={styles.bottomBar}>
            <p>© {new Date().getFullYear()} ToxBoxAI. All rights reserved.</p>
          </div>
        </div>

        {/* Quick Links */}
        <div className={styles.column}>
          <h3>Quick links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/features">Feature</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/demo-form">Demo</Link></li>
            <li><Link to="/contact">Contact us</Link></li>
          </ul>
        </div>

        {/* Legal & policies */}
        <div className={styles.column}>
          <h3>Legal & policies</h3>
          <ul>
            <li><Link to="/privacy-policy">Privacy policy</Link></li>
            <li><Link to="/terms-of-service">Terms of service</Link></li>
          </ul>
        </div>

        {/* Support & Resources */}
        <div className={styles.column}>
          <h3>Support & Resources</h3>
          <ul>
            <li><Link to="/help-center">Help center</Link></li>
            <li><Link to="/faq">FAQ's</Link></li>
            <li><Link to="/customer-support">Customer Support</Link></li>
            <li><Link to="/blogs">Blog & Updates</Link></li>
          </ul>
        </div>
      </div>

      {/* Footer Image - Bottom Right Corner */}
      <div className={styles.footerImageContainer}>
        <img
          src={footerImage}
          alt="Footer decoration"
          className={styles.footerImage}
        />
      </div>
    </footer>
  );
};

export default FooterComponent;